import React from 'react';
import styled from 'styled-components/macro';

import FramiTooltip from './FramiTooltip';
import './FramiIconButtonStyles.css';

const IconButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 8px;
    transition: opacity 0.3s;

    min-width: ${(props) => `${props.$size}px`};
    min-height: ${(props) => `${props.$size}px`};
    font-size: ${(props) => `${props.$size / 2}px`};

    pointer-events: ${(props) => (props.disabled ? 'none' : '')};

    &:disabled {
        opacity: 30%;
        cursor: unset;
    }
`;

const FramiIconButton = ({
    className,
    title,
    style,
    onClick,
    icon,
    size,
    disabled,
    dataCy,
    showTooltip,
    customTooltipStyle,
    openTooltip,
    tooltipCloseButton,
    tooltipOnClose,
    tooltipArrow,
    tooltipNotFollowCursor,
}, ref) => {

    const handleClick = (event) => {
        onClick && onClick(event);
    };

    return (
        <FramiTooltip
            title={showTooltip ? title : ''}
            tooltipStyle={customTooltipStyle}
            openTooltip={openTooltip}
            closeButton={tooltipCloseButton}
            onClose={tooltipOnClose}
            arrow={tooltipArrow}
            followCursor={!tooltipNotFollowCursor}
        >
            <span>
                <IconButton
                    aria-label={`Aria ${title}`}
                    data-cy={dataCy}
                    ref={ref}
                    className={className}
                    style={style}
                    onClick={handleClick}
                    $size={size}
                    disabled={disabled}
                >
                    {icon}
                </IconButton>
            </span>
        </FramiTooltip>
    );
};

export default React.forwardRef(FramiIconButton);
